module.exports = __webpack_public_path__ + "img/robot.e4577cc7.jpg";